import React, { Component } from 'react';

class Option extends Component {
  render() {
    let unit = this.props.unit;

    return (
      <option value={ unit.name } data-factor={ unit.factor }>
        { unit.name } { unit.abbreviation && `(${ unit.abbreviation })`}
      </option>
    );
  }
}

export default Option;
